import {Editor} from '@tinymce/tinymce-react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import '../EmptyTemplate/headerandfooter.scss';
import './editPrescription.scss';
// import React, { useState } from 'react';
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {useDispatch, useSelector} from 'react-redux';
import Swal from 'sweetalert2';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {setEmptyTemplateEdit} from '../../Redux/Slice/rootSlice';
import {putPrescriptionTemplate} from '../../Redux/Thunk/Actions';

// import SCEditorComponent from '../../Components/SCEditorComponent';

const EditPrescription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editorData, setEditorData] = useState('');
  const [editorValue, setEditorValue] = useState('');
  const patientId = useSelector(state => state.counter.patientid);
  const prescriptionId = useSelector(state => state.counter.prescriptionId);
  const emptyTemplateHtml = useSelector(state => state.counter.emptyTemplateHtml);
  const emptyTemplateEdit = useSelector(state => state.counter.emptyTemplateEdit);
  const templateName = useSelector(state => state.counter.templateName);
  var listToSplit = emptyTemplateHtml.split(`<p class="Dani"></p>`).length == 1 ? [1, emptyTemplateHtml] : emptyTemplateHtml.split(`<p class="Dani"></p>`);

  const handleEditorChange = value => {
    setEditorValue(value);
  };

  const handlesubmit = () => {
    try {
      (async () => {
        const htmlPayload = document.getElementById('emptyContainer').innerHTML;

        const payload = {
          payload: {
            prescription_template: htmlPayload,
            patient_id: patientId,
            description: '',
            template_type: templateName
          },
          prescriptionId: prescriptionId
        };

        const patentDetails = putPrescriptionTemplate(payload);
        dispatch(setEmptyTemplateEdit(false));
        const response = await dispatch(patentDetails);
        if (response?.payload?.status?.code === 200) {
          navigate('/PatientView');
          Swal.fire({
            title: 'Successful.',
            text: 'Record added successful.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        }
      })();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <>
      <div
        id='mainEmptyPage'
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
        <div className='emptyContainer'>
          <header>
            <Headers />
          </header>

          <span className='middleInput'>
            <Editor
              apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
              initialValue={listToSplit[1] !== undefined ? listToSplit[1] : ''}
              init={{
                height: '800px',
                width: '1200px',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                  'table'
                ],
                toolbar: 'table'
              }}
              onEditorChange={handleEditorChange}
            />
          </span>

          {/* <footer>
            // <Footer />
          </footer> */}
        </div>
      </div>
      <button onClick={handlesubmit} style={{width: '100px'}} className='Button_Create'>
        Save
      </button>

      {/* //*----------------------------------------------------------------------------- */}

      <div id='emptyContainer'>
        <Headers />
        <p class='Dani'></p>
        <div className='middleSpan1' style={{backgroundColor: 'white'}} dangerouslySetInnerHTML={{__html: editorValue}}></div>
        <p class='Dani'></p>
        <PrescriptionFooter />
      </div>
    </>
  );
};

export default EditPrescription;
